import './styles.css'
import APIExplorer from './../../src'

APIExplorer
  .addAPI('3dx_api', 'swagger2', '/3dx_api.json', c => {
    c.displaySummaryAtWelcome(true)
    c.listOperationsAtWelcome(true)
    c.setRequestTimeoutInMiliseconds(1000)
  })
  // .configCORS({ credentials: 'omit' })
  .start('demo')



// WEBPACK FOOTER //
// ./demo/src/index.js